"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = AlignLeft;

var _AlignLeft = require("@adobe/react-spectrum-workflow/dist/AlignLeft");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function AlignLeft(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_AlignLeft.A4uAlignLeft, null));
}